import React, { useState, useContext } from 'react';
import { Container, Row, Col, Card, Button, Nav, Table, Badge, ProgressBar, Dropdown } from 'react-bootstrap';
import { BellFill, GearFill, BoxArrowRight, Grid3x3, FileEarmarkCode, Plugin, CloudArrowUp, Activity, PeopleFill, Calendar } from 'react-bootstrap-icons';
import { AuthContext } from '../context/AuthContext';
import Subscription from './Subscription';

const UserDashboard = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const { user, logout } = useContext(AuthContext);

  const userData = {
    nome: 'Mario Rossi',
    email: user?.email || 'mario.rossi@example.com',
    planName: 'Professionale',
    apiKeys: 3,
    apiUsage: 68,
    plugins: 8,
    recentActivity: [
      { id: 1, type: 'API Call', endpoint: '/users/data', status: 'success', date: 'Oggi, 10:30' },
      { id: 2, type: 'Plugin Install', name: 'Data Sync', status: 'success', date: 'Oggi, 09:15' },
      { id: 3, type: 'API Call', endpoint: '/analytics/report', status: 'error', date: 'Ieri, 16:45' },
      { id: 4, type: 'API Key', action: 'Created', key: 'api_xG8d...', date: 'Ieri, 14:20' },
    ],
    apis: [
      { id: 1, name: 'User Authentication', status: 'Active', requests: 1250, successRate: 99.8 },
      { id: 2, name: 'Data Synchronization', status: 'Active', requests: 890, successRate: 98.5 },
      { id: 3, name: 'Payment Processing', status: 'Testing', requests: 150, successRate: 95.2 },
    ],
    plugins: [
      { id: 1, name: 'Data Export', version: '2.1.0', status: 'Active' },
      { id: 2, name: 'Authentication Extra', version: '1.3.5', status: 'Active' },
      { id: 3, name: 'Request Logger', version: '3.0.1', status: 'Active' },
      { id: 4, name: 'API Analytics', version: '2.2.0', status: 'Inactive' },
    ],
  };

  return (
    <div className="bg-light min-vh-100">
      <header className="bg-primary py-3">
        <Container>
          <Row className="align-items-center">
            <Col>
              <h1 className="text-white mb-0">API Solutions</h1>
            </Col>
            <Col className="text-end">
              <Dropdown className="d-inline-block me-2">
                <Dropdown.Toggle variant="light" id="notification-dropdown" size="sm">
                  <BellFill className="me-1" /> <Badge bg="danger">3</Badge>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item>Nuovo plugin disponibile</Dropdown.Item>
                  <Dropdown.Item>Aggiornamento di sicurezza</Dropdown.Item>
                  <Dropdown.Item>Limite API quasi raggiunto</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown className="d-inline-block me-2">
                <Dropdown.Toggle variant="light" id="settings-dropdown" size="sm">
                  <GearFill className="me-1" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <Dropdown.Item>Profilo</Dropdown.Item>
                  <Dropdown.Item>Impostazioni</Dropdown.Item>
                  <Dropdown.Item>Fatturazione</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Button variant="outline-light" size="sm" onClick={logout}>
                <BoxArrowRight className="me-1" /> Logout
              </Button>
            </Col>
          </Row>
        </Container>
      </header>

      <Container fluid className="py-4">
        <Row>
          <Col md={3} lg={2} className="mb-4">
            <Card>
              <Card.Body className="p-0">
                <div className="p-3 bg-white text-center border-bottom">
                  <div className="rounded-circle bg-primary text-white d-inline-flex align-items-center justify-content-center mb-2" style={{ width: '60px', height: '60px', fontSize: '1.5rem' }}>
                    {userData.nome.charAt(0)}
                  </div>
                  <h5 className="mb-0">{userData.nome}</h5>
                  <p className="text-muted small mb-0">{userData.email}</p>
                  <Badge bg="primary" className="mt-2">{userData.planName}</Badge>
                </div>
                <Nav className="flex-column" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                  <Nav.Link eventKey="overview" className="py-3 px-3 border-bottom">
                    <Grid3x3 className="me-2" /> Panoramica
                  </Nav.Link>
                  <Nav.Link eventKey="apis" className="py-3 px-3 border-bottom">
                    <FileEarmarkCode className="me-2" /> Le mie API
                  </Nav.Link>
                  <Nav.Link eventKey="plugins" className="py-3 px-3 border-bottom">
                    <Plugin className="me-2" /> Plugin
                  </Nav.Link>
                  <Nav.Link eventKey="usage" className="py-3 px-3 border-bottom">
                    <Activity className="me-2" /> Utilizzo
                  </Nav.Link>
                  <Nav.Link eventKey="team" className="py-3 px-3 border-bottom">
                    <PeopleFill className="me-2" /> Team
                  </Nav.Link>
                  <Nav.Link eventKey="subscriptions" className="py-3 px-3">
                    <Calendar className="me-2" /> Abbonamenti
                  </Nav.Link>
                </Nav>
              </Card.Body>
            </Card>
          </Col>

          <Col md={9} lg={10}>
            {activeTab === 'overview' && (
              <>
                <Row className="mb-4">
                  <Col md={4} className="mb-3 mb-md-0">
                    <Card className="h-100">
                      <Card.Body className="d-flex align-items-center">
                        <div className="rounded bg-primary bg-opacity-10 p-3 me-3">
                          <FileEarmarkCode className="text-primary" style={{ fontSize: '2rem' }} />
                        </div>
                        <div>
                          <h6 className="text-muted mb-1">API Keys</h6>
                          <h4 className="mb-0">{userData.apiKeys}</h4>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={4} className="mb-3 mb-md-0">
                    <Card className="h-100">
                      <Card.Body className="d-flex align-items-center">
                        <div className="rounded bg-success bg-opacity-10 p-3 me-3">
                          <CloudArrowUp className="text-success" style={{ fontSize: '2rem' }} />
                        </div>
                        <div>
                          <h6 className="text-muted mb-1">Utilizzo API</h6>
                          <h4 className="mb-0">{userData.apiUsage}%</h4>
                          <ProgressBar variant="success" now={userData.apiUsage} className="mt-2" style={{ height: '6px' }} />
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={4}>
                    <Card className="h-100">
                      <Card.Body className="d-flex align-items-center">
                        <div className="rounded bg-info bg-opacity-10 p-3 me-3">
                          <Plugin className="text-info" style={{ fontSize: '2rem' }} />
                        </div>
                        <div>
                          <h6 className="text-muted mb-1">Plugin attivi</h6>
                          <h4 className="mb-0">{userData.plugins}</h4>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <Card className="mb-4">
                  <Card.Header className="bg-white">
                    <h5 className="mb-0">Attività recenti</h5>
                  </Card.Header>
                  <Card.Body className="p-0">
                    <Table responsive hover className="mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th>Tipo</th>
                          <th>Dettagli</th>
                          <th>Stato</th>
                          <th>Data</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.recentActivity.map((activity) => (
                          <tr key={activity.id}>
                            <td>{activity.type}</td>
                            <td>
                              {activity.endpoint && <code>{activity.endpoint}</code>}
                              {activity.name && <span>{activity.name}</span>}
                              {activity.key && <code>{activity.key}</code>}
                            </td>
                            <td>
                              {activity.status === 'success' && <Badge bg="success">Successo</Badge>}
                              {activity.status === 'error' && <Badge bg="danger">Errore</Badge>}
                              {activity.action && <Badge bg="info">{activity.action}</Badge>}
                            </td>
                            <td>{activity.date}</td>
                            <td className="text-end">
                              <Button variant="outline-secondary" size="sm">Dettagli</Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
                <Card>
                  <Card.Header className="bg-white d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Le mie API</h5>
                    <Button variant="primary" size="sm">Gestisci API</Button>
                  </Card.Header>
                  <Card.Body className="p-0">
                    <Table responsive hover className="mb-0">
                      <thead className="bg-light">
                        <tr>
                          <th>Nome</th>
                          <th>Stato</th>
                          <th>Richieste</th>
                          <th>Tasso di successo</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {userData.apis.map((api) => (
                          <tr key={api.id}>
                            <td>{api.name}</td>
                            <td>
                              {api.status === 'Active' && <Badge bg="success">Attivo</Badge>}
                              {api.status === 'Testing' && <Badge bg="warning">Test</Badge>}
                            </td>
                            <td>{api.requests.toLocaleString()}</td>
                            <td>
                              <div className="d-flex align-items-center">
                                <div className="me-2">{api.successRate}%</div>
                                <ProgressBar
                                  variant={api.successRate > 98 ? 'success' : api.successRate > 95 ? 'warning' : 'danger'}
                                  now={api.successRate}
                                  style={{ height: '6px', width: '100px' }}
                                />
                              </div>
                            </td>
                            <td className="text-end">
                              <Button variant="outline-primary" size="sm" className="me-2">Analytics</Button>
                              <Button variant="outline-secondary" size="sm">Configura</Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              </>
            )}
            {activeTab === 'subscriptions' && <Subscription />}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserDashboard;